import {ApiV0} from '../api.v0';
import {RestApiService} from '../../rest-api.service';
import {ApiV0AdminIntegrations} from './administration/integrations/api.v0.admin.integrations';
import {ApiV0Server} from './administration/server/api.v0.admin.server';
import {ApiV0AdminPermissions} from './administration/api.v0.admin.permissions';
import {ApiV0AdminRoles} from './administration/api.v0.admin.roles';
import {ApiV0AdminAccounts} from './administration/api.v0.admin.accounts';
import {ApiV0AdminVariables} from './administration/api.v0.admin.variables';
import {ApiV0AdminFiscalYears} from './administration/api.v0.admin.fiscal-years';
import {ApiV0AdminRoleV3} from './administration/api.v0.admin.role.v3';

export class ApiV0Administration {
    segment = '/administration';

    constructor(
        v0: ApiV0,
        api: RestApiService,
    ) {
        this.segment = v0.segment + this.segment;
        this.integrations = new ApiV0AdminIntegrations(this, api);
        this.permissions = new ApiV0AdminPermissions(this, api);
        this.roles = new ApiV0AdminRoles(this, api);
        this.server = new ApiV0Server(this, api);
        this.accounts = new ApiV0AdminAccounts(this, api);
        this.variables = new ApiV0AdminVariables(this, api);
        this.fiscalYears = new ApiV0AdminFiscalYears(this, api);
        this.role = new ApiV0AdminRoleV3(this, api);
    }

    public readonly accounts: ApiV0AdminAccounts;
    public readonly integrations: ApiV0AdminIntegrations;
    public readonly permissions: ApiV0AdminPermissions;
    public readonly roles: ApiV0AdminRoles;
    public readonly server: ApiV0Server;
    public readonly variables: ApiV0AdminVariables;
    public readonly fiscalYears: ApiV0AdminFiscalYears;
    public readonly role:ApiV0AdminRoleV3;

}
